
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/things-you-must-know",
      function () {
        return require("private-next-pages/things-you-must-know/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/things-you-must-know"])
      });
    }
  